// src/pages/SignUpPage.tsx
import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { signupUser } from '../services/mockApi';
import { Container, FlexCenter } from '../styles/commonStyles';
import { Button } from '../components/Button';

const SignUpWrapper = styled(FlexCenter)`
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  text-align: center;
`;

const SignUpForm = styled.form`
  background: white;
  padding: ${({ theme }) => theme.spacing.medium};
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
`;

const Title = styled.h2`
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: ${({ theme }) => theme.spacing.small};
  border: 1px solid ${({ theme }) => theme.colors.muted};
  border-radius: 5px;
  font-size: 1rem;
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 0.9rem;
  margin-bottom: ${({ theme }) => theme.spacing.small};
`;

const SignUpPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState<'employee' | 'admin'>('employee');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await signupUser(username, password, role);
      navigate('/login');
    } catch (err) {
      setError('Username already exists or invalid input');
    }
  };

  return (
    <SignUpWrapper>
      <Container>
        <SignUpForm onSubmit={handleSubmit}>
          <Title>Sign Up</Title>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <Input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button as="button" type="submit">
            Sign Up
          </Button>
        </SignUpForm>
      </Container>
    </SignUpWrapper>
  );
};

export default SignUpPage;